import { render } from "./UI.vue?vue&type=template&id=63226bf1&scoped=true"
import script from "./UI.vue?vue&type=script&lang=js"
export * from "./UI.vue?vue&type=script&lang=js"

import "./UI.vue?vue&type=style&index=0&id=63226bf1&scoped=true&lang=stylus"
script.render = render
script.__scopeId = "data-v-63226bf1"

export default script